<kendo-appbar position="top" *ngIf="mediaService.isDesktop">

  <kendo-appbar-section>
    <img alt="Logo" class="logo" src="./assets/img/brand/{{brand}}/logo.png">
    <span *ngIf="isTrainingEnv" class="env-display-name">{{'global.testEnvInfoName' | translate}}</span>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  <kendo-appbar-section>
    <a *ngIf="hasAdminPanelAccess" class="navigation-tabs__link" routerLink="/adminCenter/users"> {{'layout.topToolbarAdminPanel' | translate}}</a>
  </kendo-appbar-section>

  <span *ngIf="isAccountingUser" class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <a *ngIf="isAccountingUser" role="none" class="navigation-tabs__link" (click)="getAccountingLink()"> {{'layout.topToolbarAccountingCenter' | translate}}</a>
  </kendo-appbar-section>

  <span *ngIf="isAccountingUser" class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <a *ngIf="isAccountingUser" class="navigation-tabs__link" routerLink="/reportsCenter"> {{'layout.topToolbarReportsCenter' | translate}}</a>
  </kendo-appbar-section>

  <span class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <a *ngIf="hasServicePanelAccess" class="navigation-tabs__link" routerLink="/serviceCenter/reminders">{{'layout.topToolbarServicePanel' | translate}}</a>
  </kendo-appbar-section>

  <span *ngIf="hasServicePanelAccess" class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <a class="navigation-tabs__link" routerLink="/claimsCenter">{{'layout.topToolbarClaimsPanel' | translate}}</a>
  </kendo-appbar-section>

  <span class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <div fxLayout="row">

      <button #anchor class="k-button k-button-clear profile-item" (click)="showUserProfile()">
        <kendo-icon name="user"></kendo-icon>
        <div fxLayout="column">

          <span class="user-name">{{user.userData.userName}}</span>
          <span *ngIf="!!userEmployeeProfile" class="user-profile"> {{'global.referenceTypes.' +
            userEmployeeProfile.referenceType | translate}}
            :<strong>{{userEmployeeProfile.referenceDescription}}</strong> </span>
          <div *ngIf="false">
            <span>EXP : {{sessionValidTime| date:'yyyy-MM-dd HH:mm:ss'}}</span>
            <span>NOW : {{currentTime | date:'yyyy-MM-dd HH:mm:ss'}}</span>
          </div>
        </div>

      </button>
    </div>

  </kendo-appbar-section>
  <span class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <a  class="navigation-tabs__link">
      <kendo-icon (click)="reportBug()" name="warning"></kendo-icon>
    </a>
  </kendo-appbar-section>

  <span class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
        <app-portal-switcher 
        [allowMainPortal]="false" 
        [allowMobilePortal]="true" 
        [allowWorkshopPortal]="true" 
        [allowDealerPortal]="true"
        [allowCalculationPortal]="true"
        [allowPartsSupplierPortal]="true"
        ></app-portal-switcher>
  </kendo-appbar-section>

  <kendo-appbar-section>
    <app-select-localization></app-select-localization>
  </kendo-appbar-section>

  <kendo-appbar-section>
  <app-user-portal-messages-indicator [messageServicingUrl]="'/serviceCenter/messages/userMessages'"></app-user-portal-messages-indicator>
</kendo-appbar-section>

  <span class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <a (click)="logoutUser()"   role="none"  class="navigation-tabs__link"> {{'layout.topToolbarLogout' | translate}} </a>
  </kendo-appbar-section>

</kendo-appbar>

<kendo-appbar position="top" *ngIf="mediaService.isMobile">

  <kendo-appbar-section>
    <img alt="Logo" class="logo" src="./assets/img/brand/{{brand}}/logo.png">
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  <kendo-appbar-section>
    <button #menuAnchor kendoButton fillMode="flat" icon="menu" (click)="togglePopupMenu()"> </button>
  </kendo-appbar-section>

  <kendo-popup [anchor]="menuAnchor.element" *ngIf="showPopupMenu" [margin]="margin">
    <div class="content">
      <div>
        <a class="navigation-tabs__link" routerLink="/adminCenter/users"> {{'layout.topToolbarAdminPanel' | translate}}</a>
      </div>
      <div *ngIf="isAccountingUser">
        <a  role="none" class="navigation-tabs__link" (click)="getAccountingLink()"> {{'layout.topToolbarAccountingCenter' | translate}}</a>
      </div>
      <div *ngIf="isAccountingUser">
        <a class="navigation-tabs__link" routerLink="/reportsCenter"> {{'layout.topToolbarReportsCenter' | translate}}</a>
      </div>
      <div *ngIf="hasServicePanelAccess">
        <a class="navigation-tabs__link" routerLink="/serviceCenter/reminders"> {{'layout.topToolbarServicePanel' | translate}}</a>
      </div>
      <div>
        <a class="navigation-tabs__link" routerLink="/claimsCenter"> {{'layout.topToolbarClaimsPanel' | translate}}</a>
      </div>
      <div>
        <app-portal-switcher class="navigation-tabs__link" [allowMainPortal]="false" [allowMobilePortal]="true" [allowWorkshopPortal]="true" allowDealerPortal="true"></app-portal-switcher>
      </div>
      <div>
        <app-user-portal-messages-indicator class="navigation-tabs__link" [messageServicingUrl]="'/serviceCenter/messages/userMessages'"></app-user-portal-messages-indicator>
      </div>
      <div>
        <a (click)="logoutUser()" role="none" class="navigation-tabs__link"> {{'layout.topToolbarLogout' | translate}} </a>
      </div>
    </div>
  </kendo-popup>

  <kendo-appbar-section *ngIf="isTrainingEnv">
    <span class="env-display-name">{{'global.testEnvInfoName' | translate}}</span>
  </kendo-appbar-section>


</kendo-appbar>

<router-outlet></router-outlet>
